import { Avatar } from '../Avatar'
import { ClientEntity } from './ClientEntity'

export class ClientCorpse extends ClientEntity {
  static type = 'corpse'

  getInteractInfo() {
    return this.data.interact
  }

  init() {
    this._avatar = new Avatar(this.world, this.world.uniforms.uTime, this.world.lights, {
      yBase: this.data.position.yBase,
      width: this.data.avatar.width,
      height: this.data.avatar.height,
      totalFrames: this.data.avatar.totalFrames,
      animations: this.data.avatar.animations,
      shadow: this.data.avatar.shadow,
    })
    this._avatar.setLayers(this.data.avatar.layers)
    this._avatar.setDirection(this.data.avatar.direction)
    this._avatar.freezeEmote('death')
    this._avatar.setPosition(this.data.position.x, this.data.position.y)

    if (this.data.interact) {
      const t = this.data.target || {}
      this._action = this.world.targets.add({
        px: this.data.position.x,
        py: this.data.position.y,
        oy: t.oy ?? 0,
        radius: t.radius || 0,
        value: this,
      })
    }
  }

  onChange(changes) {
    if (changes.position) {
      this._avatar?.setPosition(this.data.position.x, this.data.position.y)
      this._action?.setPosition(this.data.position.x, this.data.position.y)
    }
  }

  canInteract() {
    return !!this.data.interact
  }

  destroy() {
    this._avatar?.destroy()
    this._action?.destroy()
    super.destroy()
  }
}
